console.log(
  "process.env.REACT_APP_IS_BACKOFFICE_USER",
  process.env.REACT_APP_IS_BACKOFFICE_USER
);
export const isBackofficeUser =
  window.location.hostname.includes("bo.") ||
  process.env.REACT_APP_IS_BACKOFFICE_USER === "true";
